import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { CloseComplaint } from "../../store/actions/user-action";
import { useNavigate, useLocation } from "react-router-dom";

const ManageComplaintPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { complaint } = location.state;
  const [formState, setFormState] = useState({
    remark: "",
    actionType: "", // Now a string to hold 'continue' or 'discontinue'
  });

  const handleRemarkChange = (e) => {
    setFormState((prevState) => ({
      ...prevState,
      remark: e.target.value,
    }));
  };

  const handleServiceAction = (type) => {
    setFormState((prevState) => ({
      ...prevState,
      actionType: type,
    }));
  };

  const handleSubmit = () => {
    if (!formState.actionType) {
      alert("Please select continue or discontinue.");
      return;
    }

    let payload = {
      complaintId: complaint._id,
      adminRemarks: formState.remark,
      orderItemId: complaint.order_item_id._id,
      triggerNotidfications: formState.actionType === "continue",
    };

    dispatch(CloseComplaint(payload));

    navigate("/complaints"); // Navigate back after form submission
  };

  return (
    <div className="p-4">
      {" "}
      {/* Outer div for padding */}
      <div className="p-[25px] rounded-md border-[solid] border bg-white">
        <h2 className="text-xl font-bold mb-4">Manage Complaint</h2>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">
            Remarks
          </label>
          <textarea
            value={formState.remark}
            onChange={handleRemarkChange}
            className="w-full h-32 p-2 border border-gray-300 rounded-md" // Adjust height here
            rows={20} // You can set the number of rows to make it larger
            placeholder="Enter your remark here..."
          />
        </div>
        <div className="flex space-x-4">
          <button
            className={`px-4 py-1 rounded ${
              formState.actionType === "continue"
                ? "bg-green-500 text-white"
                : "bg-gray-200"
            }`}
            onClick={() => handleServiceAction("continue")}
          >
            Continue Service
          </button>
          <button
            className={`px-4 py-1 rounded ${
              formState.actionType === "discontinue"
                ? "bg-red-500 text-white"
                : "bg-gray-200"
            }`}
            onClick={() => handleServiceAction("discontinue")}
          >
            Discontinue Service
          </button>
        </div>
        <button
          className="mt-4 px-3 py-1 bg-blue-500 text-white rounded"
          onClick={handleSubmit} // Change from onSubmit to onClick
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default ManageComplaintPage;
